<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-2">
                    <button class="btn btn-primary btn-sm btn-block" :disabled="idSelect.length == 0 || loading"
                        @click="availability()">Gia hạn</button>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-6">
                            <ldc-select
                                placeholder="Chọn danh mục"
                                v-model="data.category"
                                @change="emitModel()">
                                <ldc-option
                                    v-for="(item, index) in categories" :key="index"
                                    :value="item.id"
                                    :label="`${item.name} ( ${item.count} )`"/>
                        </ldc-select>
                        </div>
                        <div class="col-6">
                            <ldc-select
                                placeholder="Loại tin"
                                v-model="data.expire"
                                @change="getExp()">
                                <ldc-option
                                    v-for="(data, index) in exp" :key="index"
                                    :value="data.id"
                                    :label="data.name"/>
                            </ldc-select>
                        </div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-9">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px"
                                placeholder="Nhập #id hoặc tiêu đề tin"
                                @keyup.enter="enterKeyword()" v-model="data.keyword"/>
                                <div class="btn-search position-absolute" @click="enterKeyword()">
                                    <span class="lable-search px-10px">
                                        <i class="icon ion-ios-search fs-20px"></i>
                                    </span>
                                </div>
                                <div class="text-warning-search fs-10px position-absolute">
                                    * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> )
                                </div>
                            </div>
                        </div>
                        <div class="col-3">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;" @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div input-search>
                    <div content-input-search class="search-box position-relative">
                        <input type="text" placeholder="Nhập id hoặc tiêu đề tin" v-model="data.keyword" @keyup.enter="enterKeyword()"/>
                        <div class="text-warning-search fs-10px"> * Ghi # để tìm kiếm theo id ( vd: <i>#123456</i> ) </div>
                    </div>
                </div>
                <div class="d-flex mb-10px">
                    <div class="w-50 pr-1">
                        <button type="button" class="btn btn-primary btn-action-check btn-block fs-14px px-1" :disabled="idSelect.length == 0 || loading"
                            @click="availability()">
                            Gia hạn
                        </button>
                    </div>
                    <div class="w-50 pl-1">
                        <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                            @click="fillterMobile = true">
                            <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                        </button>
                    </div>
                </div>
            </div>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="false"
                :showTitle="true"
                title="Lọc tin rao"
                :customButton="true"
                :visible.sync="fillterMobile">
                <div slot="content-model"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Chọn danh mục"
                            title="Lọc theo danh mục"
                            v-model="data.category">
                            <ldc-option-mobile
                                v-for="(item, index) in categories" :key="index"
                                :value="item.id"
                                :label="`${item.name} ( ${item.count} )`"/>
                        </ldc-select-mobile>
                    </div>
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Loại tin"
                            title="Loại tin"
                            v-model="data.expire"
                            @change="getExp()">
                            <ldc-option-mobile
                                v-for="(data, index) in exp" :key="index"
                                :value="data.id"
                                :label="data.name"/>
                        </ldc-select-mobile>
                    </div>
                </div>
                <div slot="custom-buttom"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div :class="{
                        'btn-confirm-android': $isAndroid,
                        'btn-confirm-ios mb-10px': !$isAndroid
                        }">
                        <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply"
                            @click="emitModel()" close-model-mobile>áp dụng</button>
                        <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel"
                            @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                    </div>
                </div>
            </ldc-model-mobile>
        </div>
    </div>
</template>

<script>
import { availability } from '@/config/raovat';
export default {
    props: ['value', 'idSelect'],
    data() {
        return {
            loading: false,
            categories: [],
            data: {
                category: 0,
                expire: 1,
                keyword: '',
            },
            fillterMobile: false,
            exp: [
                {
                    "id": 1,
                    "name": "Hết hạn dưới 1 năm"
                },
                {
                    "id": 2,
                    "name": "Hết hạn trên 1 năm"
                }
            ]
        }
    },
    watch: {
        value: {
            handler(val){
                this.data = val;
            },
            deep: true,
        },
    },
    created(){
        this.getCategory(1);
    },
    methods: {
        async availability(){
            this.loading = true;
            await availability(this.idSelect, this);
            this.loading = false;
            await this.$eventBus.$emit('call-page-expire', true);
        },
        getCategory(expire) {
            let params = {
                expire: this.data.expire,
            };
            this.data.category = 0;
            apiGet('/v2/profile/raovat/group_category_expire', params).then(res => {
                this.categories = res.data;
            });
        },
        emitModel(){
            this.$emit('input', {
                category: this.data.category,
                expire: this.data.expire,
                keyword: this.data.keyword,
            })
        },
        enterKeyword(){
            this.emitModel();
        },
        removeFillter(){
            this.data = {
                category: 0,
                expire: 1,
                keyword: '',
            };
            this.emitModel();
        },
        getExp() {
            this.getCategory(this.data.expire);
            this.data.keyword = '';
            this.emitModel();
        }
    }
}
</script>

<style lang="scss">
.ldc-model-mobile {
    .value-select-mobile {
        text-align: right;
    }
}
</style>
